import React from 'react';
import { Box, Button, Flex, Text, Dropdown } from '@goodrx/matisse';
import { onNpiLearnMore } from 'app/lib/analytics';

interface ProviderDetailsProps {
  trigger: React.ReactElement;
  name: string;
  npi: string;
}

export const ProviderModal: React.FC<ProviderDetailsProps> = ({ trigger, name, npi }) => (
  <Dropdown
    placement="bottom-start"
    boundariesElement="scrollParent"
    positionFixed
    width={250}
    zIndex={999999}
    offset="16px"
    trigger={trigger}>
    <>
      <Flex pl={2} pt={2} pb={2}>
        <Box>
          <strong style={{ display: 'block' }}>{name}</strong>
          <Text color="greyDarker" fontSize={12}>
            NPI # {npi}
          </Text>
        </Box>
      </Flex>
      <Dropdown.Divider />
      <Button
        variant="greyText"
        as="a"
        leftIcon="information"
        href="https://en.wikipedia.org/wiki/National_Provider_Identifier"
        target="_blank"
        pl={1}
        onClick={onNpiLearnMore}>
        <Text fontWeight={500} pl={1}>
          Learn More
        </Text>
      </Button>
    </>
  </Dropdown>
);
